import {PlayerReducer, ReducerFromState} from "../../../@types/reducers";

export const isInitialized = (state: ReducerFromState<PlayerReducer>): boolean => state.player.initializing;